export default __webpack_public_path__ + "static/media/7.dfdd7c67.png";